import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate } from 'react-router-dom';
import { resetPasswordSendCode } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";

export default function ForgotPasswordPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
    email: "",
  });

  
  
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 

  const handleSubmit = (e) => {
    
    e.preventDefault();

    console.log(formData);

    resetPasswordSendCode(formData.email).then((res) => {
      if (res.error === true) {
        Swal.fire({
          text: res.msg,
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      } else {
        
        Swal.fire({
          text: "Se ha enviado un email con el código de recuperación.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        navigate('/recuperar-password/verificar-codigo/' + res.uuid);
       
      }
    });
  };

  

  return (
    <div>
      <div className="mc-auth" translate="no">
        {/* Header con logo */}
        <div className="mc-auth-header">
          <img src="images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
          <div className="mc-auth-help">
            <div className="mc-auth-feature-icon">
              <img src="images/support.png" alt="Soporte" />
            </div>
            <span>¿Necesitas ayuda?</span>
            <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
          </div>
        </div>

        {/* Contenedor principal */}
        <div className="mc-auth-container">
          {/* Contenedor único - Bienvenida y Formulario */}
          <div className="mc-auth-welcome">
            <div className="mc-auth-welcome-content">
              <h1 className="mc-auth-welcome-title">Recupera tu<br />contraseña</h1>
              <p className="mc-auth-welcome-subtitle">Ingresa tu email para recibir el código de recuperación.</p>
            </div>

            {/* Formulario de recuperación */}
            <div className="mc-auth-form-wrapper">
              <h2 className="mc-auth-form-title">Recuperar Contraseña</h2>
              <p className="mc-auth-form-subtitle">Ingresa tu email para continuar</p>

              <form className="mc-auth-form" onSubmit={handleSubmit} translate="no">
                <div className="mc-auth-input-group">
                  <IconFieldComponent
                    icon="email"
                    type="email"
                    name="email"
                    required
                    classes="w-100"
                    placeholder="correo@ejemplo.cl"
                    onChange={handleInputChange}
                  />
                </div>

                <ButtonComponent className="mc-auth-btn-submit" type="submit">
                  ENVIAR CÓDIGO
                </ButtonComponent>

                <AnchorComponent className="mc-auth-forgot-link" to="/login">
                  ¿Recuerdas tu contraseña? Volver a login
                </AnchorComponent>
              </form>
            </div>
          </div>
        </div>

        {/* Footer con características */}
        <footer className="mc-auth-footer">
          <div className="mc-auth-footer-content">
            <div className="mc-auth-feature-card">
              <div className="mc-auth-feature-icon">
                <img src="/images/trips.png" alt="Mis Giras" onError={(e) => e.target.style.display = 'none'} />
              </div>
              <h3 className="mc-auth-feature-title">Mis Giras</h3>
              <p className="mc-auth-feature-desc">Revisa itinerarios, fechas, servicios y documentos de tus giras.</p>
            </div>

            <div className="mc-auth-feature-card">
              <div className="mc-auth-feature-icon">
                <img src="/images/passengers.png" alt="Pasajeros" onError={(e) => e.target.style.display = 'none'} />
              </div>
              <h3 className="mc-auth-feature-title">Pasajeros</h3>
              <p className="mc-auth-feature-desc">Consulta la lista de pasajeros, datos y documentación.</p>
            </div>

            <div className="mc-auth-feature-card">
              <div className="mc-auth-feature-icon">
                <img src="/images/payments.png" alt="Pagos" onError={(e) => e.target.style.display = 'none'} />
              </div>
              <h3 className="mc-auth-feature-title">Pagos</h3>
              <p className="mc-auth-feature-desc">Visualiza montos y fechas de pagos de tu gira.</p>
            </div>

            <div className="mc-auth-feature-card">
              <div className="mc-auth-feature-icon">
                <img src="/images/documents.png" alt="Documentos" onError={(e) => e.target.style.display = 'none'} />
              </div>
              <h3 className="mc-auth-feature-title">Documentos</h3>
              <p className="mc-auth-feature-desc">Descarga contratos, coberturas y documentos importantes.</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}